import { FC, useState } from 'react';
import styled, { css } from 'styled-components';

import Text from '@/components/Text';

const InfoIconHolder = styled.span<{ $type?: 'bank' | 'user' | 'basic' }>`
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  height: 12px;
  svg {
    color: ${({ theme }) => theme.colors.warning};
    ${({ $type }) =>
      $type === 'bank' &&
      css`
        color: ${({ theme }) => theme.colors.info};
      `}
    ${({ $type }) =>
      $type === 'user' &&
      css`
        color: ${({ theme }) => theme.colors.error};
      `}
  }
`;

const TooltipBox = styled.div<{ $type?: 'bank' | 'user' | 'basic' }>`
  position: absolute;
  padding: 4px;
  width: 68px;
  z-index: 11;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  border-radius: 4px;
  bottom: calc(100% + 8px);
  left: -28px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  position: absolute;
  text-align: center;
  ${({ $type }) =>
    $type === 'bank' &&
    css`
      width: 88px;
      left: -38px;
    `}
  ${({ $type }) =>
    $type === 'user' &&
    css`
      width: 90px;
      left: -39px;
    `}
`;

const Triangle = styled.div`
  width: 26px;
  height: 14px;
  position: absolute;
  overflow: hidden;
  bottom: -14px;
  left: 0;
  right: 0;
  margin: auto;
  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    background: ${({ theme }) => theme.colors.white};
    transform: rotate(45deg);
    top: -8px;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
  }
`;

interface Props {
  type?: 'bank' | 'user' | 'basic';
  isFreelancer?: boolean;
}

const InvoicesWarning: FC<Props> = ({ type = 'basic', isFreelancer }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const renderText = () => {
    if (type === 'bank') return 'Add bank details';
    if (type === 'user') return 'Missing user info';
    return `New ${isFreelancer ? 'account' : 'receiver'}`;
  };

  return (
    <>
      <InfoIconHolder
        onMouseOver={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        $type={type}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            r="5.5"
            transform="matrix(1 0 0 -1 6 6)"
            fill="currentColor"
            stroke="currentColor"
          />
          <path
            d="M5.5 7.69853V8.625H6.5V7.69853H5.5ZM5.5 3.375V7.08088H6.5V3.375H5.5Z"
            fill="white"
          />
        </svg>
        {!!showTooltip && (
          <TooltipBox $type={type}>
            <Triangle />
            <Text $type="extraSmall">{renderText()}</Text>
          </TooltipBox>
        )}
      </InfoIconHolder>
    </>
  );
};

export default InvoicesWarning;
